import { useForm, Controller } from 'react-hook-form'
import DAIButton from 'src/DAIComponents/Input/Button/DAIButton'
import { DAIForm } from 'src/DAIComponents/Form/DAIForm'
import {
  AppointmentSettingsForm,
  appointmentSettingsSchema,
  Calendar,
} from '../SettingsTypes'
import { zodResolver } from '@hookform/resolvers/zod'
import WeeklyAvailabilityGrid, {
  AvailabilityMatrix,
} from './WeeklyAvailabilityGrid'

export function AppointmentSettingsFormComponent({
  calendars,
  calendarData,
  onSubmit,
}: {
  calendars: Calendar[]
  calendarData?: AppointmentSettingsForm
  onSubmit: (data: AppointmentSettingsForm) => void
}) {
  const defaultMatrix: AvailabilityMatrix = Array(7)
    .fill(0)
    .map(() => Array(24).fill(false))
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<AppointmentSettingsForm>({
    defaultValues: {
      calendarId: calendarData?.calendarId ?? '',
      availability: calendarData?.availability ?? defaultMatrix,
    },
    resolver: zodResolver(appointmentSettingsSchema),
  })

  return (
    <DAIForm onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      {/* Calendar select */}
      <div>
        <label className="block text-sm font-medium text-gray-900 mb-1">
          Select Calendar
        </label>
        <select
          {...register('calendarId', { required: true })}
          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
        >
          <option value="" disabled>
            -- Select a calendar --
          </option>
          {calendars.map(calendar => (
            <option
              key={calendar.id}
              value={calendar.id}
              disabled={calendar.is_read_only}
            >
              {calendar.name} {calendar.is_primary ? '(Primary)' : ''}
              {calendar.is_read_only && ' (Read-only)'}
            </option>
          ))}
        </select>
        {errors.calendarId && (
          <p className="text-sm text-red-500 mt-1">
            {errors.calendarId.message}
          </p>
        )}
      </div>
      {/* Weekly availability */}
      <Controller
        name="availability"
        control={control}
        render={({ field }) => (
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Weekly Availability
            </label>
            <WeeklyAvailabilityGrid
              value={field.value}
              onChange={field.onChange}
            />
          </div>
        )}
      />
      <DAIButton text="Save Preferences" buttonType="submit" />
    </DAIForm>
  )
}
